import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc/ui-design-system';

export const SomethingWrong = () => (
  <Box display='flex' justifyContent='center' alignItems='center' height='100vh'>
    <Typography color='error' data-testid='something-went-wrong-msg'>
      Something went wrong. Please try again.
    </Typography>
  </Box>
);
